module.exports = __webpack_public_path__ + "img/7_185.cec919d2.png";